import { render, staticRenderFns } from "./Outofstock.vue?vue&type=template&id=68401832&scoped=true"
import script from "./Outofstock.vue?vue&type=script&lang=js"
export * from "./Outofstock.vue?vue&type=script&lang=js"
import style0 from "./Outofstock.vue?vue&type=style&index=0&id=68401832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68401832",
  null
  
)

export default component.exports